module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"vacancy":"Вакансия","candidates":"Кандидаты","interview":"Интервью","questions":"Вопросы"}}')
  delete Component.options._Ctor
}
